import { ErrorMessage } from '@components/core-ui/ErrorMessage';
import { ButtonMedium } from '@components/core-ui/form-elements/buttons/Button/variations/PrimaryButtonSizes';
import { Input } from '@components/core-ui/form-elements/Input';
import CheckEmail from '@components/icons/CheckEmail.svg';
import EmailIcon from '@components/icons/Email.svg';
import { Spinner } from '@components/core-ui/spinners/Spinner';
import { routes } from '@routes';
import React from 'react';
import { useNavigate } from 'react-router';
import { usePageContext } from '../../providers/PageProvider';
import { StyledIconWrapper } from './styles/StyledIconWrapper';
import { Wrapper } from './styles/Wrapper';

export const PasswordRecoveryPageContent = () => {
  const { isComplete, email, setEmail, setError, isLoading, error, recovery, resetForm } = usePageContext();
  const navigate = useNavigate();

  const handleFormSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    evt.preventDefault();
    recovery();
  };

  const backToLogin = (evt: React.MouseEvent) => {
    evt.preventDefault();
    navigate(routes.signin.make());
  };

  const goToRegistration = (evt: React.MouseEvent) => {
    evt.preventDefault();
    navigate(routes.signup.make());
  };

  const resend = (evt: React.MouseEvent) => {
    evt.preventDefault();
    resetForm();
  };

  if (isComplete) {
    return (
      <Wrapper>
        <StyledIconWrapper>
          <CheckEmail className="checkEmailIcon" />
        </StyledIconWrapper>
        <h1 className="completePlease">Check Your Email</h1>
        <h2 className="completeWeSent">
          We sent a password reset link to <br /> {email}
        </h2>
        <h3 className="completeDidnt">
          {'Didn’t receive the email?'}&nbsp;&nbsp;
          <span onClick={resend} className="completeResend">
            Click here to resend
          </span>
        </h3>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {isLoading && <Spinner overlay={true} />}
      <div className="root">
        <div className="content">
          <div>
            <h1 className="forgotPassword">Forgot Password?</h1>
            <h2 className="noWorries">No worries, we’ll send you reset instructions.</h2>
          </div>

          <div className="form">
            <form onSubmit={handleFormSubmit}>
              <div className="mb-[30px]">
                <Input
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError('');
                  }}
                  name="email"
                  label="Email"
                  type="text"
                  value={email || ''}
                  required={true}
                  icon={EmailIcon}
                />
              </div>

              {error ? (
                <div className="formError">
                  <ErrorMessage error={error} />
                </div>
              ) : null}

              <ButtonMedium disabled={!email || isLoading} type="submit" className="mb-[30px] mx-auto w-full">
                Reset Password
              </ButtonMedium>

              <a href="#" className="backToLogin" tabIndex={-1} onClick={backToLogin}>
                ← Back to log in
              </a>

              <p className="dontHaveAnAccount">
                {"Don't have an account yet? "}&nbsp;&nbsp;
                <span onClick={goToRegistration} className="signUp">
                  Sign Up
                </span>
              </p>
            </form>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
